import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
   export const getAllClassPeriodTeacherscheduleMapping = async (formData) =>
    commonFetch(API_URLS.GET_ALL_ASSIGN_CLASS_PERIOD_TO_TEACHER, {
      method: "POST",
      body: formData,
      requiresAuth: true,
    });

